var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9908 0.519531C12.2213 0.519531 12.4424 0.6111 12.6054 0.774104C12.7684 0.937107 12.8599 1.15819 12.8599 1.38871V22.2491C12.8599 22.4796 12.7684 22.7007 12.6054 22.8637C12.4424 23.0267 12.2213 23.1183 11.9908 23.1183C11.7602 23.1183 11.5392 23.0267 11.3762 22.8637C11.2132 22.7007 11.1216 22.4796 11.1216 22.2491V1.38871C11.1216 1.15819 11.2132 0.937107 11.3762 0.774104C11.5392 0.6111 11.7602 0.519531 11.9908 0.519531ZM1.56059 10.9497H22.4209C22.6515 10.9497 22.8726 11.0413 23.0356 11.2043C23.1986 11.3673 23.2901 11.5884 23.2901 11.8189C23.2901 12.0494 23.1986 12.2705 23.0356 12.4335C22.8726 12.5965 22.6515 12.6881 22.4209 12.6881H1.56059C1.33007 12.6881 1.10898 12.5965 0.945979 12.4335C0.782975 12.2705 0.691406 12.0494 0.691406 11.8189C0.691406 11.5884 0.782975 11.3673 0.945979 11.2043C1.10898 11.0413 1.33007 10.9497 1.56059 10.9497Z",
    fill: "#01537A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.2fdd054afbae76595402b22c668f4bff.svg";
export { ForwardRef as ReactComponent };